module.exports = __webpack_public_path__ + "static/group-1-306d59b615ea1d790bd233f26036a000.png";